import { render, staticRenderFns } from "./AGroup.vue?vue&type=template&id=3b4b710b"
import script from "./AGroup.vue?vue&type=script&lang=js"
export * from "./AGroup.vue?vue&type=script&lang=js"
import style0 from "./AGroup.vue?vue&type=style&index=0&id=3b4b710b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports